module.exports = __webpack_public_path__ + "img/ic_notification_delete.67b8ef6b.svg";